"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button"));
var Input_1 = __importDefault(require("../Input"));
var Button_2 = __importDefault(require("../Input/Button"));
var Modal_1 = __importStar(require("../Modal"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var utilities_1 = require("../utilities");
var Option_1 = __importDefault(require("./Options/Option"));
var utils_1 = require("./utils");
var StyledModal = styled_components_1.default(Modal_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  bottom: ", ";\n"], ["\n  bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
var Options = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  flex: 1 0 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n"], ["\n  font-size: ", ";\n  flex: 1 0 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n"])), polished_1.em(18));
var LargeInput = styled_components_1.default(Input_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 18px;\n  height: ", ";\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid ", " !important;\n  & ~ button {\n    border: 0 !important;\n    border-radius: 0 !important;\n    border-bottom: 1px solid ", " !important;\n  }\n"], ["\n  font-size: 18px;\n  height: ", ";\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid ", " !important;\n  & ~ button {\n    border: 0 !important;\n    border-radius: 0 !important;\n    border-bottom: 1px solid ", " !important;\n  }\n"])), polished_1.rem(50), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
});
var DisabledOption = styled_components_1.default('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-style: italic;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-style: italic;\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inactiveColor;
});
function default_1(props) {
    var inputValue = props.inputValue, onChangeInput = props.onChangeInput, opened = props.opened, onClose = props.onClose, multiple = props.multiple, value = props.value, loading = props.loading, onSelectOption = props.onSelectOption, createNewOption = props.createNewOption, onChange = props.onChange, options = props.options, renderLabel = props.renderLabel;
    var _a = React.useState(value), localValue = _a[0], setLocalValue = _a[1];
    var inputEl = React.useRef(null);
    React.useEffect(function () {
        if (opened && inputEl && inputEl.current) {
            inputEl.current.focus();
        }
    }, [opened]);
    React.useEffect(function () {
        setLocalValue(value);
    }, [value, opened]);
    var defaultCreateOption = React.useMemo(function () { return utils_1.getDefaultCreateOption(inputValue); }, [inputValue]);
    function handleSelectOption(selectedOption) {
        if (multiple) {
            if (Array.isArray(localValue)) {
                var idx = localValue.findIndex(function (val) {
                    return val.value === selectedOption.value;
                });
                if (idx === -1) {
                    setLocalValue(__spreadArrays(localValue, [selectedOption]));
                }
                else {
                    setLocalValue(localValue.filter(function (v) { return v.value !== selectedOption.value; }));
                }
            }
        }
        else {
            onSelectOption(selectedOption);
            onClose();
        }
    }
    function renderOptions() {
        if (options.length > 0) {
            var allOptions = options.map(function (option, idx) { return (React.createElement(Option_1.default, { key: idx, option: option, onSelectOption: handleSelectOption, useCheckbox: multiple, selected: utils_1.isOptionSelected(option, localValue), renderLabel: renderLabel, idx: idx })); });
            if (createNewOption &&
                inputValue &&
                !utils_1.containsExactMatch(options, inputValue)) {
                var idx = options.length;
                allOptions.push(React.createElement(Option_1.default, { key: idx, idx: idx, option: defaultCreateOption, onSelectOption: function (selectedOption) {
                        if (multiple && Array.isArray(localValue)) {
                            var newOption = createNewOption(inputValue);
                            onChangeInput('');
                            setLocalValue(__spreadArrays(localValue, [newOption]));
                        }
                        else {
                            onSelectOption(selectedOption);
                            onClose();
                        }
                    } }));
            }
            return allOptions;
        }
        if (loading) {
            return (React.createElement(DisabledOption, null,
                utilities_1.__('Moment,'),
                React.createElement("br", null),
                utilities_1.__('načítavajú sa možnosti ...')));
        }
        return React.createElement(DisabledOption, null, utilities_1.__('Žiadne možnosti'));
    }
    return (React.createElement(StyledModal, { isOpen: opened, handleClose: onClose },
        React.createElement(LargeInput, { inputRef: inputEl, value: inputValue, onChange: function (e) {
                onChangeInput(e.target.value);
            } },
            React.createElement("input", null),
            inputValue ? (React.createElement(Button_2.default, { icon: "backspace", onClick: function () {
                    onChangeInput('');
                } })) : (React.createElement(Button_2.default, { icon: "close", onClick: onClose }))),
        React.createElement(Options, null, renderOptions()),
        React.createElement(Modal_1.ModalActions, null,
            React.createElement(Button_1.default, { onClick: onClose }, utilities_1.__('Zrušiť')),
            multiple && (React.createElement(Button_1.default, { primary: true, onClick: function () {
                    onChange(localValue);
                    onClose();
                } }, utilities_1.__('Potvrdiť'))))));
}
exports.default = default_1;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
